import { render, staticRenderFns } from "./ProofChangeFolder.vue?vue&type=template&id=2eb981a7"
import script from "./ProofChangeFolder.vue?vue&type=script&lang=js"
export * from "./ProofChangeFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports